import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { SignupIntentChoices } from "./SignupIntentChoices";

export type SignupIntentModalProps = {
  open: boolean;
  onClose: () => void;
  /** Path-only return URL (e.g. /people?people_profile=finish). */
  redirectUrl?: string | null;
};

export const SignupIntentModal: React.FC<SignupIntentModalProps> = ({
  open,
  onClose,
  redirectUrl = null,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="signup-intent-title"
      aria-describedby="signup-intent-description"
    >
      <DialogTitle id="signup-intent-title" sx={{ pr: 6 }}>
        What type of account do you need?
        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography
          id="signup-intent-description"
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2 }}
        >
          Choose the option that best describes how you will use American Police
          Training. The next step opens the matching application.
          {redirectUrl ? (
            <>
              {" "}
              After signup you can finish creating your public People profile.
            </>
          ) : null}
        </Typography>
        <SignupIntentChoices redirectUrl={redirectUrl} onChosen={onClose} />
      </DialogContent>
    </Dialog>
  );
};
